// extracted by mini-css-extract-plugin
module.exports = {"container":"landingpage_container__qYa40","intro":"landingpage_intro__3Pcd7","name":"landingpage_name__2wB58","brief":"landingpage_brief__27x5G","mypic":"landingpage_mypic__2uXNN"};